import { DataFilterModel } from '@/app/shared/models';
import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';

export class DataService extends HttpService {
  public async getDataFilterList(
    dataFilter: DataFilterModel,
    limit = 999
  ): Promise<DataFilterModel[]> {
    if (!dataFilter.StatusList || dataFilter.StatusList.length == 0) {
      dataFilter.StatusList = [
        'Registered',
        'Active',
        'Suspended',
        'Finalized',
        'Canceled',
        'Denied',
        'CanceledByDefaulter',
        'CanceledByChargeBack',
        'RenewInProgress',
        'DefaulterExternal',
      ];
    }
    return await this.post<DataFilterModel[], DataFilterModel>(
      `${env.searchUri}/Data/Filter`,
      { ...dataFilter, Limit: limit }
    ).then(({ data }) => data);
  }
}
